/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { GraphQLDocuments } from "@graphql/graphQLDocuments";
import { GetLogisticReportsCsvMutation, GetLogisticReportsCsvMutationVariables } from "@models/graphql";

const defaultGetLogisticReportsCsvOptions: MutationHookOptions<GetLogisticReportsCsvMutation, GetLogisticReportsCsvMutationVariables> = {};

export const useGetLogisticReportsCsv = (
    options?: MutationHookOptions<GetLogisticReportsCsvMutation, GetLogisticReportsCsvMutationVariables>
) => {
    const [mutation, { data, loading, error }] = useMutation<GetLogisticReportsCsvMutation, GetLogisticReportsCsvMutationVariables>(
        GraphQLDocuments.getLogisticReportsCSV
    );

    const getLogisticReportsCsv = async (variables: GetLogisticReportsCsvMutationVariables) => {
        try {
            const response = await mutation({
                ...defaultGetLogisticReportsCsvOptions,
                ...options,
                variables
            });

            return {
                error: response.errors,
                data: response.data
            };
        } catch (err) {
            return {
                error: err
            };
        }
    };

    return {
        isLoading: loading,
        error,
        data,
        getLogisticReportsCsv
    };
};
